export default "__VITE_ASSET__d8c525ff__"